import React from "react";
import DatePicker from "react-datepicker";
import PasswordStrengthBar from "react-password-strength-bar";
import "react-datepicker/dist/react-datepicker.css";
/* eslint-disable */
export const regexMobile = /^(09|\+639)\d{9}$/;
export const regexEmail =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const pageLimit = [5, 10, 20, 30, 40, 50, 100];

export const TextInput = ({
  type,
  label,
  name,
  value,
  onchange,
  max,
  required,
  _class,
  isEmail,
  isMobile,
  isValid,
  isPassword,
  isStrength,
}) => (
  <div className={_class ? "form-group " + _class : "form-group"}>
    <label>
      {label} {required && <span className="text-danger">*</span>}
    </label>
    <input
      type={type || "text"}
      name={name}
      value={value}
      maxLength={max}
      className="form-control"
      onChange={(e) =>
        onchange({
          target: {
            value: e.target.value,
            name: e.target.name,
            isEmail,
            isPassword,
            isMobile,
          },
        })
      }
      autoComplete="off"
      required={required}
    />
    {isStrength && value && (
      <PasswordStrengthBar password={value} minLength="8" />
    )}

    {isEmail && value && !isValid && (
      <small className="text-danger">Invalid email address</small>
    )}

    {isMobile && value && !isValid && (
      <small className="text-danger">Invalid mobile number</small>
    )}

    {isPassword && value && !isValid && (
      <small className="text-danger">Password mismatch</small>
    )}
  </div>
);

export const DropdownPageLimit = ({ name, value, onchange, _class }) => (
  <div className={_class ? "form-group " + _class : "form-group"}>
    <div className="input-group">
      <div className="input-group-prepend">
        <span className="input-group-text">Page Limit</span>
      </div>
      <select
        name={name}
        value={value}
        className="form-control"
        onChange={onchange}
        autoComplete="off"
      >
        <option value="" selected disabled hidden>
          Choose here
        </option>
        {pageLimit &&
          pageLimit.map((item, index) => (
            <option key={index} value={parseInt(item)}>
              {item}
            </option>
          ))}
      </select>
    </div>
  </div>
);

export const DropdownInput = ({
  label,
  name,
  value,
  onchange,
  max,
  required,
  items,
  _class,
  isLoading,
  initialValue,
}) => (
  <div className={_class ? "form-group " + _class : "form-group"}>
    {label && (
      <label>
        {label} {required && <span className="text-danger">*</span>}{" "}
        {isLoading && <i className="fas fa-spinner fa-spin"></i>}
      </label>
    )}
    <select
      name={name}
      value={value}
      maxLength={max}
      className="form-control"
      onChange={onchange}
      autoComplete="off"
      required={required}
    >
      <option value="" selected disabled hidden>
        Choose here
      </option>
      {items &&
        items.map((item, index) => (
          <option key={index} value={item.value}>
            {item.text}
          </option>
        ))}
    </select>
  </div>
);

export const DateInput = ({
  type,
  label,
  name,
  value,
  onchange,
  max,
  required,
  _class,
}) => (
  <div className={_class ? "form-group " + _class : "form-group"}>
    <label>
      {label} {required && <span className="text-danger">*</span>}
    </label>
    <br />
    <DatePicker
      selected={value}
      onChange={(e) => onchange({ target: { name, value: e } })}
      name={name}
      onClickOutside
      className="form-control"
    />
  </div>
);

export const TextBox = (props) => (
  <div className={props._class ? "form-group " + props._class : "form-group"}>
    <label>
      {props.label} {props.required && <span className="text-danger">*</span>}
    </label>
    <input
      type={props.type || "text"}
      name={props.name}
      value={props.value}
      maxLength={props.max}
      className="form-control"
      onChange={(e) => props.onChange(e.target.value)}
      autoComplete="off"
      required={props.required}
    />
    {props.isStrength && props.value && (
      <PasswordStrengthBar password={props.value} minLength="8" />
    )}

    {props.isEmail && props.value && !props.isValid && (
      <small className="text-danger">Invalid email address</small>
    )}

    {props.isMobile && props.value && !props.isValid && (
      <small className="text-danger">Invalid mobile number</small>
    )}

    {props.isPassword && props.value && !props.isValid && (
      <small className="text-danger">Password mismatch</small>
    )}
  </div>
);

export const DropdownList = (props) => (
  <div className={props._class ? "form-group " + props._class : "form-group"}>
    {props.label && (
      <label>
        {props.label} {props.required && <span className="text-danger">*</span>}{" "}
        {props.isLoading && <i className="fas fa-spinner fa-spin"></i>}
      </label>
    )}
    <select
      name={props.name}
      value={props.value}
      maxLength={props.max}
      className="form-control"
      onChange={(e) => props.onChange(e.target.value)}
      autoComplete="off"
      required={props.required}
      defaultValue=""
    >
      <option selected disabled hidden>
        Choose here
      </option>
      {props.items &&
        props.items.map((item, index) => (
          <option key={index} value={item.value}>
            {item.text}
          </option>
        ))}
    </select>
  </div>
);

export const Select = (props) => (
  <div className={props._class}>
    <label
      htmlFor="country"
      className="block text-sm font-medium text-gray-700"
    >
      {props.label}
    </label>
    <select
      name={props.name}
      autoComplete="off"
      value={props.value}
      defaultValue=""
      onChange={(e) => props.onChange(e.target.value)}
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    >
      <option disabled>
        {props.placeholder ? props.placeholder : "select item"}
      </option>
      {props.items &&
        props.items.length > 0 &&
        props.items.map((i, idx) => (
          <option key={idx} value={i.value}>
            {i.text}
          </option>
        ))}
    </select>
  </div>
);

export const Input = (props) => (
  <div className={props._class}>
    <label
      htmlFor="last-name"
      className="block text-sm font-medium text-gray-700"
    >
      {props.label}
    </label>
    <input
      type={props.type ? props.type : "text"}
      name={props.name}
      autoComplete="off"
      value={props.value}
      onChange={(e) => props.onChange(e.target.value)}
      className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    />
  </div>
);

export const InputDialog = (props) => (
  <>
    <label
      htmlFor="last-name"
      className="block text-sm font-medium text-gray-700"
    >
      {props.label}
    </label>
    <div className="col-span-2">
      <input
        type={props.type ? props.type : "text"}
        name={props.name}
        autoComplete="off"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        className=" mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      />
      {props.isEmail && !props.valid && props.value && (
        <em className="text-xs text-red-600">Invalid email address</em>
      )}

      {props.isMobile && !props.valid && props.value && (
        <em className="text-xs text-red-600">Invalid mobile number</em>
      )}
    </div>
  </>
);

export const InputLabel = (props) => (
  <div className={props._class}>
    <label
      htmlFor="last-name"
      className="block text-sm font-medium text-gray-400"
    >
      <em>{props.label}</em>
    </label>
    <label className="mt-1 block w-full py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
      {props.value}
    </label>
  </div>
);
